<template>
  <div class="main-body">
    <main-header></main-header>
    <section class="main-body-section">
      <div class="main-login">
<!--        <div class="main-login-logo">-->
<!--          <picture class="login-logo">-->
<!--            <source srcset="/login-logo.webp" type="image/webp">-->
<!--            <img src="/login-logo.jpg" alt="login-logo"/>-->
<!--          </picture>-->
<!--          <div></div>-->
<!--          <div>-->
<!--            <div class="logo-title">WIMS</div>-->
<!--            <div-->
<!--                :class="{-->
<!--              'logo-desc': true,-->
<!--              'logo-desc-en': $i18n.locale === 'en'-->
<!--                }">-->
<!--              {{ $t('login.center_text') }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="login-title">
          <img :src="require(`../../public/logo-bg${$i18n.locale === 'en' ? '-en' : ''}.svg`)" alt="Logo" />
        </div>

        <el-form ref="loginForm" :rules="rules" :model="loginForm">
          <el-form-item prop="username" class="ms-content-form login-content-form">
            <el-input v-model.trim="loginForm.username" :placeholder="$t('login.username_placeholder')"
                      prefix-icon="el-icon-user"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="ms-content-form">
            <el-input type="password" :placeholder="$t('login.password_placeholder')" v-model.trim="loginForm.password"
                      prefix-icon="el-icon-lock"
                      @keyup.enter.native="submitForm" show-password>
            </el-input>
          </el-form-item>
          <el-form-item class="ms-content-form">
            <div style="display: flex; justify-content: space-between">
              <el-checkbox v-model="loginForm.savePassword">{{ $t('login.remember_password') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-button style="width: 100%" type="primary" :loading="loading" @click="submitForm">{{
              $t('login.btn_login')
            }}
          </el-button>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import {delCookie, getCookie, setCookie} from "../utils/cookie";
import {rasDecrypt} from "../utils/rsa";
import {loginIn} from "@/api/userCenterManage";
import {setEncrypt} from "../utils/encrypt";
import {getNewLoginWarehouseList, loginInOWMS} from "@/api/loginOWMS";
import MainHeader from "@/components/main-header/index.vue";

export default {
  components: {MainHeader},
  data() {

    return {
      url: "",

      // 第一次修改用户名
      userFirstChange: false,

      // 用户信息
      userInfo: {},

      // 取消用户民后缀
      cancelUserSuffix: false,

      loginForm: {
        username: "",
        password: "",
        savePassword: false,
        fullPassword: "",
      },

      // 登录
      loading: false,
      rules: {
        username: [
          {required: true, validator: this.validateName, trigger: "blur"},
        ],
        password: [{required: true, validator: this.validatePass, trigger: "blur"}],
      },
      systemType: ''
    };
  },
  created() {
    // 获取登录名称
    this.loginForm.username = getCookie("userName") || "";
    this.loginForm.fullPassword = getCookie("password") || "";
    if (this.loginForm.fullPassword) {
      let password = rasDecrypt(this.loginForm.fullPassword);
      if (password != null && password.length) {
        for (let i = 0; i < password.length; i++) {
          this.loginForm.password += " ";
        }
      }
    }
    this.loginForm.savePassword = getCookie("savePassword") !== "";
    if (this.$route.query && this.$route.query.systemType) {
      this.systemType = this.$route.query.systemType
    }
  },
  watch: {
    '$i18n.locale'() {
      this.rules = {
        username: [
          {required: true, validator: this.validateName, trigger: "blur"},
        ],
        password: [{required: true, validator: this.validatePass, trigger: "blur"}],
      }
    }
  },

  methods: {
    validateName(rule, value, callback){
      if (!value) {
        callback(new Error(this.$t('login.username_message')));
      } else {

        callback();
      }
    },
    validatePass(rule, value, callback){
      if (!value) {
        callback(new Error(this.$t('login.password_message')));
      } else {

        callback();
      }
    },
    async getWarehouseList() {
      window.sessionStorage.removeItem("tokenO");
      let initWareHouse = "";
      try {
        let res = await getNewLoginWarehouseList({
          userName: this.loginForm.username,
        });
        if (res.code !== "200") {
          this.$message.error("Error");
          return;
        }
        initWareHouse = res.data[0].warehouseCode || initWareHouse;
        if (!initWareHouse) {
          return;
        }
        const response = await loginInOWMS({
          userName: this.loginForm.username,
          password: setEncrypt(this.loginForm.password),
          warehouseCode: initWareHouse,
          step: "2",
        })
        const isError = response.code !== "200"
        const token = isError ? "" : response.data.token.accessToken

        const data = {
          warehouseCode: initWareHouse,
          token,
          realName: isError ? '' : response.data.realName,
          username: isError ? '' : response.data.username,
          userImageUrl: isError ? '' : response.data.userImageUrl,
          rmsUserId: isError ? '' : response.data.userId,
          owmsUserId: isError ? '' : response.data.owmsUserId,
        }
        const storeData = JSON.stringify(data);
        window.sessionStorage.setItem("OWMS_DATA", storeData);
        window.sessionStorage.setItem("OWMS_OWMS_TOKEN", token);
      } catch (e) {
        console.log(286286, e);
      }
    },
    // 点击登陆验证
    submitForm() {
      console.log(this.loginForm)
      this.$refs.loginForm.validate((valid) => {
        console.log('valid', valid)
        if (valid) {
          this.loading = true;
          this.handleLogin();
        } else {
          return false;
        }
      });
    },
    handleLogin() {
      Promise.all([
        this.confirmLogin(),
        this.getWarehouseList()
      ]).then(() => {
        let queryData = {}
        if (this.systemType == 'newUserCenter') {
          queryData = {
            systemType: 'newUserCenter'
          }
        } else {
          queryData = {}
        }
        this.$router.replace({
          path: '/selectPage',
          query: queryData,
        });
      });
    },

    // 登录
    async confirmLogin() {
      // 设置密码加密
      let password = JSON.parse(JSON.stringify(this.loginForm.password.trim()));
      let res
      let userInfo = ''
      res = await loginIn({username: this.loginForm.username, password: setEncrypt(password), clientType: 'WIMS'})

      // 请求
      if (res.code === "200") {
        let newUserCenterGroupName = ''
        if (res.data.organizationList && res.data.organizationList.length > 0) {
          let newUserCenterOrganizationList = res.data.organizationList[0]
          if (newUserCenterOrganizationList) {
            newUserCenterGroupName = newUserCenterOrganizationList.chineseName
          }
        }

        userInfo = {
          "realName": res.data.realName,
          "token": res.data.oldRmsLoginResult
              ? res.data.oldRmsLoginResult.token : res.data.token ? res.data.token.accessToken : '',
          "token2": res.data.token ? res.data.token.accessToken : '',
          "userId": res.data.oldRmsLoginResult ? res.data.oldRmsLoginResult.userId : res.data.userId,
          "userId2": res.data.userId,
          "userName": res.data.username,
          "wimsUserId": res.data.wimsUserId,
          "groupName": newUserCenterGroupName,
          "itDepartment": res.data.itDepartment,
        }

        // 设置用户信息
        window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        window.sessionStorage.setItem("WMS_LOGIN_INFO", JSON.stringify(res.data));
        this.$store.commit("userInfo", res.data.userName);
        this.userInfo = res.data;

        // 是否保存密码
        // 保存用户名
        setCookie("userName", this.loginForm.username, 10080);
        // 旧的userName 未区分大小写, 有问题, 这里重新设置一个
        setCookie("userNameResponse", res.data.username, 10080);
        if (this.loginForm.savePassword) {
          setCookie("password", password, 10080);
          setCookie("savePassword", this.loginForm.savePassword, 10080);
        } else {
          delCookie("password");
          delCookie("savePassword");
        }
        this.$message.success(this.$t('login.login_success'));
        this.loading = false;
      } else {
        this.$message.error(res.msg);
        this.loading = false;
      }
      this.loading = false;
    },


  },
};
</script>

<style lang="scss" scoped>
.main-body {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #0d213c;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/login-bg.jpg");
  /* 浏览器支持 WebP 格式时，使用 WebP 图 */
  @supports (background-image: url("data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA")) {
    background-image: url("/login-bg.webp");
  }

  &-section {
    width: 100%;
    height: calc(100% - 60px);
    display: grid;
    place-items: center;
  }
}


.main-login {
  ::v-deep {
    .el-checkbox {
      height: 30px;
      line-height: 30px;
    }

    .el-input__inner {
      border-radius: 6px;
    }
  }
  width: 416px;
  height: max-content;
  padding: 32px 48px 48px;
  background-color: #ffffff;
  border-radius: 6px;

  &-logo {
    display: grid;
    grid-template-columns: 56px 1px 250px;
    gap: 8px;
    place-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    > div:nth-child(2){
      width: 1px;
      height: 48px;
      background-color: #2c3c65;
    }
    > div:last-child{
      width: 250px;
      font-size: 20px;
      line-height: 22px;
      font-weight: 600;
      color: rgb(44, 60, 101);
    }
    .logo-desc-en {
      white-space: nowrap;
      font-size: 12px;
      transform: scale(0.86) translateX(-19px);
    }
  }

  .login-title {
    margin-bottom: 36px;
    img {
      width: 100%;
    }
  }

}

</style>
